import {
  CommentIcon,
  CopyIcon,
  PrintIcon,
  SaveIcon,
  ZoomInIcon,
  ZoomOutIcon,
} from '@/assets/icons';
import fbIcon from '@/assets/images/fbIcon.png';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import Divider from './Divider';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';
import { FacebookShareButton } from 'react-share';

const ActionIsland = ({
  handlePrint,
  totalComment,
  handleIncreaseFontSize,
  handleDecreaseFontSize,
}: {
  handleIncreaseFontSize: () => void;
  handleDecreaseFontSize: () => void;
  handlePrint: () => void;
  totalComment: number;
}) => {
  const router = useRouter();
  const [currentDomain, setCurrentDomain] = useState('');

  const copyTextToClipboard = async (text: string) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  };
  const handleCopyUrl = () => {
    copyTextToClipboard(`${currentDomain}${router.asPath}`).then(() => {
      toast.success('Đã copy link');
    });
  };

  useEffect(() => {
    if (window) setCurrentDomain(window.location.origin);
  }, []);
  return (
    <>
      <div
        style={{ animation: 'animate-moveinleft 0.5s ease-in-out' }}
        className="bg-white shadow-lg xl:bg-transparent p-3 rounded-full w-fit flex flex-col gap-[10px] items-center"
      >
        <div className="border-[1px] border-[#cebfbf] rounded-full flex flex-col w-fit p-1 gap-4 ">
          <ZoomInIcon
            className="cursor-pointer"
            onClick={handleIncreaseFontSize}
          />
          <div className="text-[15px] leading-[24px] flex items-end justify-center">
            a <p className="text-[24px] leading-[24px]">a</p>
          </div>
          <ZoomOutIcon
            className="cursor-pointer"
            onClick={handleDecreaseFontSize}
          />
        </div>
        <div
          onClick={handleCopyUrl}
          className="border-[1px] border-[#8D8D8D] rounded-full items-center justify-center flex w-[32px] h-[32px] cursor-pointer"
        >
          <CopyIcon />
        </div>

        <FacebookShareButton url={`${currentDomain}${router.asPath}`}>
          <div className=" rounded-full items-center justify-center flex w-[32px] h-[32px] cursor-pointer">
            <Image src={fbIcon} alt={'fb'} />
          </div>
        </FacebookShareButton>
        <div className="border-[1px] border-[#8D8D8D] rounded-full items-center justify-center flex w-[32px] h-[32px] cursor-pointer">
          <CommentIcon />
        </div>
        <p className="text-[#8D8D8D] ">{totalComment}</p>
        <Divider marginY="0" />
        <div className="border-[1px] border-primary rounded-full items-center justify-center flex w-[32px] h-[32px] cursor-pointer">
          <SaveIcon />
        </div>
        <div
          onClick={handlePrint}
          className="border-[1px] border-[#8D8D8D] rounded-full items-center justify-center flex w-[32px] h-[32px] cursor-pointer"
        >
          <PrintIcon />
        </div>
      </div>
    </>
  );
};

export default ActionIsland;
